// extracted by mini-css-extract-plugin
export var container = "Projects-module--container--1rQKS";
export var title = "Projects-module--title--2zCKX";
export var projectsContainer = "Projects-module--projectsContainer--3ShW1";